import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class PictoColumns {
	constructor() {
		this.sections = document.querySelectorAll('.picto-columns');
		this.animate();
	}

	animate() {
		this.sections.forEach((section) => {
			const timeline = new TimelineLite();

			const title = section.querySelectorAll('.title, .surtitle');
			if (title.length) {
				const titleAnimation = TweenMax.staggerFromTo(
					title,
					0.3,
					{ x: -300, autoAlpha: 0 },
					{ x: 0, autoAlpha: 1 },
					0.1
				);
				timeline.add(titleAnimation);
			}

			const block = section.querySelectorAll('.picto-columns__column');
			const blockAnimation = TweenMax.staggerFromTo(
				block,
				0.3,
				{ x: -300, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1 },
				0.15
			);
			timeline.add(blockAnimation);

			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 0.85,
				reverse: false,
			})
				.setTween(timeline)
				.addTo(ScrollMagicController.controller);
		});
	}
}

export default PictoColumns;
